/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var __links = document.links;
for (let i = 0, __linksLength = __links.length ; i < __linksLength ; i++) {
    if (__links[i].hostname !== window.location.hostname) {
        __links[i].target = '_blank';
        __links[i].relList.add('noreferrer', 'noopener');
    }
}

/*
    Event listener for the customized hover fields
 */

var __addToCartButtons = document.querySelectorAll(".add-to-cart-btn");
__addToCartButtons.forEach(function(btn){
    btn.addEventListener('click', function(evt){
        evt.stopPropagation();
        evt.preventDefault();
        var variantId = evt.target.dataset.productId;
        Bloom.storefront.utilities.addToCart(variantId, 1, {}, "ajax_cart"); 
    })
});